import { ApiClient } from '@webapp/core/services/ApiClient'
import { BudgetRepository } from './BudgetRepository'

export const budgetRepository = new BudgetRepository({
  httpClient: ApiClient,
})
